export enum SupplierCreateOptions {
  CREATE_NEW = 0,
  SELECT_IN_HOUSE = 1
}
